<template>
  <div class="component_container">
    <div id="radarChart"></div>
  </div>
</template>
<script>
export default {
  name: "radarEchart",
  props: {
    dataObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      todayPvSta: 0,
      todayUvSta: 0,
      yesterdayPvSta: 0,
      yesterdayUvSta: 0,
      weekPvSta: 0,
      weekUvSta: 0,
      monthPvSta: 0,
      monthUvSta: 0,
    };
  },
  mounted() {
    this.getDataMethod();
  },
  methods: {
    renderEchartsMethod() {
      console.log('this.dataObj=>',this.dataObj)
      //初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("radarChart"));
      //绘制图表
      var option = {
        title: {
          text: " ",
        },
        grid: {
          //同radar里的center[]
          position: "center",
        },
        tooltip: {
          confine: true,
          enterable: true, //鼠标是否可以移动到tooltip区域内
        },
        //多个线条时，使用时name:'图一'区分
        //					legend: {
        //						data: ['图一', '图二']
        //					},
        radar: {
          center: ["50%", "58%"], //调位置
          radius:60, //调大小
          startAngle: 90,
          splitNumber: 5, //雷达图圈数设置
          //雷达图形状圆形    	shape:'circle',
          name: {
            formatter: "{value}",
            textStyle: {
              color: "#fff",
              fontWeight: "bold",
            },
          },
          //雷达图的指示器，指定雷达图的多个维度
          indicator: [
            {
              text: "组织运行指数",
              max: 5,
            },
            {
              text: "服务活力指数",
              max: 5,
            },
            {
              text: "专业指数",
              max: 5,
            },
            {
              text: "堡垒指数",
              max: 5,
            },
            {
              text: "公益评价指数",
              max: 5,
            },
          ],

          splitArea: {
            show: true,
            areaStyle: {
              color: [
                // "rgba(114, 172, 209, 1)", //图表背景颜色
                // "white", //图表背景颜色
              ],
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              // color: "rgba(255, 255, 255, 1)", //网格颜色
              color: "#eee", //网格颜色
            },
          },
          //雷达图中间射线的颜色
          axisLine: {
            lineStyle: {
              // color: "rgba(255, 255, 255, 1)",
              color: "#eee",
            },
          },
        },

        series: [
          {
            name: "社会组织发展情况",
            type: "radar",
            symbol: "circle", //拐点样式
            symbolSize: 2, //拐点大小
            areaStyle: {
              //拐点颜色
              narmal: {
                width: 1,
                opacity: 0.2,
                color: "rgba(19, 94, 206, 1)",
              },
            },
            data: [
              {
                //设置各个指标的值
                value: this.dataObj.type1,
                //									name: '图一',
                //让数值在拐点处显示
                label: {
                  show: false,
                  formatter: function (params) {
                    return params.value;
                  },
                },
                //设置区域边框和区域的颜色
                // itemStyle: {
                //   normal: {
                //     color: "rgba(255, 255, 0, 1)",
                //     lineStyle: {
                //       color: "rgba(255, 255, 0, 1)",
                //     },
                //   },
                // },
                itemStyle: {
                  normal: {
                    color: "rgba(19, 94, 206, 1)",
                  },
                },
                // areaStyle: {
                //   normal: {
                //     color: "rgba(233, 169, 51, 1)",
                //   },
                // },
              },
              {
                //设置各个指标的值
                value: this.dataObj.type2,
                //									name: '图一',
                //让数值在拐点处显示
                label: {
                  show: false,
                  formatter: function (params) {
                    return params.value;
                  },
                },
                //设置区域边框和区域的颜色
                // itemStyle: {
                //   normal: {
                //     color: "rgba(255, 255, 0, 1)",
                //     lineStyle: {
                //       color: "rgba(255, 255, 0, 1)",
                //     },
                //   },
                // },
                itemStyle: {
                  normal: {
                    color: "rgba(233, 169, 51, 1)",
                  },
                },
                // areaStyle: {
                //   normal: {
                //     color: "rgba(10, 229, 87, 1)",
                //   },
                // },
              },
            ],
          },
        ],
      };
      //防止越界，重绘echarts（例如屏幕缩小，图标随屏幕适应）
      window.onresize = myChart.resize;
      myChart.setOption(option); //设置option
    },

    /**
     * 获取数据的方法
     */
    getDataMethod() {
      this.renderEchartsMethod();
    },
  },
  watch: {
    dataObj() {
      this.getDataMethod();
    },
  },
};
</script>
<style lang="less" scoped>
.component_container {
  z-index: 100;
  width: 100%;
  height: 100%;
  color: #fff;
  padding-top: 0PX;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
#radarChart {
  width: 100%;
  height: 100%;
}
</style>